import * as Sentry from '@sentry/react';
import { API } from "../utils/amplifyWrapper";
import { useCallback, useEffect, useState } from "react";

export const useVerifyCheckout = () => {

    const [verifyingCheckout, setVerifyingCheckout] = useState(false);

    const verifyCheckout = useCallback(async () => {

        const urlParts = window.location.pathname.split('/').splice(1);
        const orgId = urlParts[1];

        setVerifyingCheckout(true);
        API.post('main', `/organisation/${orgId}/validate_checkout`, {})
            .then(() => {
                // Stay on the screen the user upgraded from (Chargebee already
                // redirected the browser back to the originating page). Strip the
                // checkout query params so the hook doesn't re-fire, and reload so
                // the newly unlocked plan/credits are reflected.
                window.location.replace(window.location.pathname);
            })
            .catch((error) => {
                Sentry.captureException(error)
            })
            .finally(() => {
                setVerifyingCheckout(false);
            })
    }, []);

    useEffect(() => {
        const search = window.location.search;
        const isCheckoutSuccess = (search.includes('id=') && search.includes('state=succeeded'));

        if (isCheckoutSuccess) {
            verifyCheckout();
        }

    }, [verifyCheckout])

    return verifyingCheckout

}